import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import TopHeroMarquee from "./HeroCourseSlider";
import PerformanceSection from "./PerformanceSection";
import ReportSection from "./ReportSection";

import WalletCards from "./WalletCard";
import WelcomeCard from "./WelcomeCard";
import axios from "../../../../axios";
import UpcomingContests from "./UpcomingContest";
import RechargeOfferCard from "./RechargeOfferCard";
import CourseProgressCard from "./CourseProgressCard";
import CreditBalanceCard from "./CreditBalanceCard";
import ChallengeCard from "./ChallengeCard";
import {
  ArrowRight,
  BarChart3,
  ClipboardList,
  FileQuestion,
  Trophy,
  Wallet,
  Check,
} from "lucide-react";
import courseThumb from "../../../../Images/dupci.png";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const getArrayFromResponse = (response) => {
  const data = response?.data;
  const result = data?.result || data?.data;

  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.mockTests)) return result.mockTests;
  if (Array.isArray(result?.tests)) return result.tests;
  if (Array.isArray(data?.mockTests)) return data.mockTests;
  if (Array.isArray(data)) return data;

  return [];
};

const getSelectedExamId = (userData) => {
  const selectedExam =
    userData?.selectedExam?._id ||
    userData?.selectedExam ||
    userData?.exam?._id ||
    userData?.exam ||
    userData?.examId ||
    localStorage.getItem("examId");

  return selectedExam ? String(selectedExam) : "";
};

const getResultPayload = (response) => {
  const data = response?.data;
  const result = data?.result || data?.data;

  return result?.attempt || result || {};
};

const hasSubmittedResult = (payload) =>
  Boolean(
    payload &&
      Object.keys(payload).length &&
      (payload?._id ||
        payload?.attemptId ||
        payload?.submittedAt ||
        payload?.score !== undefined ||
        payload?.totalQuestions !== undefined),
  );

const StartQuizepage2 = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const[userData,setUserData]=useState(null);
  const [hasPurchased, setHasPurchased] = useState(false); 
  const [userAnalaysis,setUserAnalaysis] = useState(null);
  const [loginUser, setLoginUser] = useState(null);
    const [activeTab, setActiveTab] = useState("all");
     const [loading, setLoading] = useState(false);
  const [mockStarting, setMockStarting] = useState(false);
  const [welcomeMockTest, setWelcomeMockTest] = useState(null);
  const [welcomeMockSubmitted, setWelcomeMockSubmitted] = useState(false);
  const [selectedExamMockTests, setSelectedExamMockTests] = useState([]);
  const [selectedExamMockTestsLoading, setSelectedExamMockTestsLoading] = useState(false);
  const courseProgress = Math.round(
    ((userData?.quizStats?.totalRight || 0) / 1000) * 100
  );

    const fetchLeaderboard = async () => {
      try {
        setLoading(true);
  
        // login user id
        const userId = localStorage.getItem("userId");
  
        const res = await axios.get(
          `/learderBoard?filter=${activeTab.toLowerCase()}`,
        );
  
        setLoginUser(res?.data?.result?.loginUser);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

  const quickActions = [
    {
      title: "Play Quiz",
      subtitle: `${userData?.unifiedWallet?.contestBalance || "0"} Credits` ,
      icon: ClipboardList,
      iconWrap: "bg-[#F2E8FF]",
      iconColor: "text-[#7B35D8]",
      button: "bg-[#7B35D8]",
      link:"/dash/quize"
    },
    {
      title: "Join Contest",
      subtitle: "5 Live Contests",
      icon: Trophy,
      iconWrap: "bg-[#FFF3DF]",
      iconColor: "text-[#FF8A1C]",
      button: "bg-[#FF7A1A]",
      link:"/dash/contest"
    },
    {
      title: "My Wallet",
      subtitle: `${userData?.unifiedWallet?.balance || "1.4k"} Credits`,
      icon: Wallet,
      iconWrap: "bg-[#EAF8F0]",
      iconColor: "text-[#21A85B]",
      button: "bg-[#26A957]",
      link:"/dash/wallet" 
    },
    {
      title: "Leaderboard",
      subtitle: `${loginUser?.rank || "Not Ranked"}`,
      icon: BarChart3,
      iconWrap: "bg-[#EEF4FF]",
      iconColor: "text-[#3E7BE8]",
      button: "bg-[#3E7BE8]",
      link:"/dash/leaderboard"
    },
  ];

  const startMockTestFromDashboard = async (mockTest) => {
    const mockTestId =
      mockTest?._id ||
      mockTest?.id ||
      mockTest?.mockTestId ||
      "";

    if (!mockTestId) {
      navigate("/dash/mock-tests");
      return;
    }

    try {
      setMockStarting(true);
      await axios.post(`/mock-tests/${mockTestId}/start`);
      navigate(`/dash/mock-test/${mockTestId}?start=${mockTestId}`);
    } catch (error) {
      toast.error("Unable to start mock test");
    } finally {
      setMockStarting(false);
    }
  };

  const renderExploreMockTests = () => (
  <div className="w-full">
    {selectedExamMockTestsLoading ? (
      <div className="flex min-h-[160px] items-center justify-center rounded-2xl bg-white">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-[#562566] border-t-transparent" />
      </div>
    ) : selectedExamMockTests.length ? (
      <Swiper
        modules={[Autoplay]}
        spaceBetween={16}
        slidesPerView={1}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={selectedExamMockTests.length > 1}
        className="w-full"
      >
        {selectedExamMockTests.map((mockTest) => {
          const mockTestId =
            mockTest?._id ||
            mockTest?.id ||
            mockTest?.mockTestId ||
            "";

          const title =
            mockTest?.title ||
            mockTest?.name ||
            mockTest?.mockTestName ||
            "Police Full Mock Test";

          const duration =
            mockTest?.durationMinutes ||
            mockTest?.duration ||
            30;

          const totalQuestions =
            mockTest?.totalQuestions ||
            mockTest?.questions?.length ||
            mockTest?.questionCount ||
            50;

          const isAttempted =
            mockTest?.attempted ||
            mockTest?.isAttempted ||
            mockTest?.status === "attempted";

          return (
            <SwiperSlide key={mockTestId || title}>
              <div
                className="
                relative
                w-full
                overflow-hidden
                rounded-2xl
                border
                border-[#E8DDF0]
                bg-white
                p-3
                shadow-[0_8px_24px_rgba(52,22,63,0.08)]
              "
              >
              <div className="flex items-start gap-3">
                <div className="flex h-[70px] w-[70px] shrink-0 items-center justify-center rounded-2xl bg-[#F0ECF8]">
                  <FileQuestion
                    className="h-8 w-8 text-[#4B2D83]"
                    strokeWidth={1.8}
                  />
                </div>

                <div className="min-w-0 flex-1">
                  <h4 className="text-[20px] font-bold leading-tight text-[#34163F]">
                    {title}
                  </h4>

                  <div className="mt-3 flex flex-wrap items-center gap-2 text-[13px] text-gray-500">
                    <span>{totalQuestions} Questions</span>

                    <span className="text-gray-300">•</span>

                    <span>{duration} min</span>

                    <span className="text-gray-300">•</span>

                    <span>Full Syllabus</span>
                  </div>
                </div>
              </div>

              <div className="mt-2 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2">
                  <div className="flex h-7 w-7 items-center justify-center rounded-full bg-[#DFF7E8]">
                    <Check
                      className="h-4 w-4 text-[#16A34A]"
                      strokeWidth={3}
                    />
                  </div>

                  <span className="text-sm font-semibold text-gray-600">
                    {isAttempted ? "Attempted" : "Not Attempted"}
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => startMockTestFromDashboard(mockTest)}
                  disabled={mockStarting}
                  className="
                    inline-flex
                    items-center
                    gap-2
                    rounded-full
                    bg-[#4B2D83]
                    px-6
                    py-3
                    text-sm
                    font-bold
                    text-white
                    shadow-[0_5px_12px_rgba(75,45,131,0.25)]
                    transition
                    hover:bg-[#3F246F]
                    active:scale-[0.98]
                    disabled:cursor-not-allowed disabled:opacity-70
                  "
                >
                  {isAttempted ? "View Result" : mockStarting ? "Starting..." : "Start Test"}

                  {isAttempted ? (
                    <BarChart3 className="h-5 w-5" />
                  ) : (
                    <ArrowRight className="h-4 w-4" />
                  )}
                </button>
              </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    ) : (
      <div className="mt-3 rounded-xl bg-white/50 px-3 py-4 text-left text-[11px] font-medium text-gray-500 sm:text-xs">
        No mock tests found for your selected exam.
      </div>
    )}
  </div>
);

  const handleStartSelectedExamMockTest = async () => {
    const examId = getSelectedExamId(userData);

    if (!examId) {
      toast.error("Please select exam first");
      navigate("/dash/select-exam");
      return;
    }

    try {
      setMockStarting(true);
      let firstMockTest = welcomeMockTest;

      if (!firstMockTest?._id) {
        const response = await axios.get(`/exams/${examId}/mock-tests`);
        const mockTests = getArrayFromResponse(response);
        firstMockTest = mockTests[0];
      }

      if (!firstMockTest?._id) {
        toast.error("No mock test is available for this exam");
        return;
      }

      navigate(`/dash/mock-test/${firstMockTest._id}?start=${firstMockTest._id}`);
    } catch (error) {
      toast.error("Unable to start mock test");
    } finally {
      setMockStarting(false);
    }
  };

  const handleViewSelectedExamMockReport = () => {
    if (!welcomeMockTest?._id) {
      toast.error("Mock test report is not available");
      return;
    }

    navigate(`/dash/mock-test-result/${welcomeMockTest._id}`);
  };

  useEffect(() => {
    axios.get("getAllCourses").then((response) => {
      if (response?.data?.result) {
        const activeCourses = response.data.result.filter(
          (course) => course.isActive === true,
        );

        console.log(activeCourses);

        setData(activeCourses);

        localStorage.setItem("plans", JSON.stringify(activeCourses));
      }
    });
  }, []);

  useEffect(()=>{
    try {
      axios.get("me").then((response)=>{
        const userData = response?.data?.result;

        if (userData) {
          setUserData(userData);
        }

        if(userData?.planName !== "Test"){
           setHasPurchased(true);
        }
      });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, []);
  useEffect(()=>{
    try {
      axios.get("analytics").then((response)=>{
       
          const userAnalaysis = response.data.result;
          console.log("User Analysis:", userAnalaysis);
          setUserAnalaysis(userAnalaysis);
      });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, []);

  useEffect(() => {
    if (!hasPurchased) {
      setSelectedExamMockTests([]);
      return undefined;
    }

    const examId = getSelectedExamId(userData);

    if (!examId) {
      setSelectedExamMockTests([]);
      return undefined;
    }

    let isActive = true;

    const loadSelectedExamMockTests = async () => {
      setSelectedExamMockTestsLoading(true);

      try {
        const response = await axios.get(`/exams/${examId}/mock-tests`);
        const mockTests = getArrayFromResponse(response);

        if (isActive) {
          setSelectedExamMockTests(mockTests.slice(0, 8));
        }
      } catch {
        if (isActive) {
          setSelectedExamMockTests([]);
        }
      } finally {
        if (isActive) {
          setSelectedExamMockTestsLoading(false);
        }
      }
    };

    loadSelectedExamMockTests();

    return () => {
      isActive = false;
    };
  }, [hasPurchased, userData]);

  useEffect(() => {
    const examId = getSelectedExamId(userData);

    if (!examId) return undefined;

    let isActive = true;

    const loadWelcomeMockStatus = async () => {
      try {
        const response = await axios.get(`/exams/${examId}/mock-tests`);
        const mockTests = getArrayFromResponse(response);
        const firstMockTest = mockTests[0] || null;

        if (!isActive) return;

        setWelcomeMockTest(firstMockTest);
        setWelcomeMockSubmitted(false);

        if (!firstMockTest?._id) return;

        try {
          const resultResponse = await axios.get(
            `/mock-tests/${firstMockTest._id}/my-result`,
            { params: userData?._id ? { userId: userData._id } : {} },
          );

          if (!isActive) return;

          setWelcomeMockSubmitted(
            hasSubmittedResult(getResultPayload(resultResponse)),
          );
        } catch {
          if (isActive) {
            setWelcomeMockSubmitted(false);
          }
        }
      } catch {
        if (isActive) {
          setWelcomeMockTest(null);
          setWelcomeMockSubmitted(false);
        }
      }
    };

    loadWelcomeMockStatus();

    return () => {
      isActive = false;
    };
  }, [userData]);

  return (
    <div className="h-full bg-bgBlue/10 mt-2 mb-10 overflow-hidden">
      <div className="w-full lg:pt-10 ">
        {hasPurchased ? (
          <>
            <div className="lg:hidden">
              <div className="grid grid-cols-1 gap-2 mx-4 my-2 items-stretch">
                <div className="">
                  <WelcomeCard
                    hasPurchased={hasPurchased}
                    onStartMockTest={handleStartSelectedExamMockTest}
                    onViewMockReport={handleViewSelectedExamMockReport}
                    mockStarting={mockStarting}
                    mockSubmitted={welcomeMockSubmitted}
                  />
                </div>
                 <div> <h2 className="text-lg text-left font-bold text-[#171321] ">
          Available Mock Tests
        </h2> </div>
                {renderExploreMockTests()}

                <div className="">
                  <CreditBalanceCard />
                </div>

                <div className="flex w-full gap-4 lg:mt-10">
                  <Link to="/dash/quize">
                  <WalletCards hasPurchased={hasPurchased} userData={userData} userAnalaysis={userAnalaysis}  />
                  </Link>
                  <Link to="/dash/contest">
                  <RechargeOfferCard userData={userData} userAnalysis={userAnalaysis}/>
                  </Link>
                </div>

                <div className="lg:col-span-2 flex flex-col lg:flex-row gap-2 w-full">
                  <div className="lg:w-1/2 pb-20 lg:pb-0">
                    <ChallengeCard />
                  </div>

                  <div className="hidden sm:block w-full lg:w-1/2 ">
                    <PerformanceSection userData={userData} />
                  </div>
                </div>
              </div>
            </div>

            <div className="hidden lg:grid lg:grid-cols-[74%_24%] gap-6 mx-2 my-2 items-start">
              <div className="space-y-5">
                <WelcomeCard
                  hasPurchased={hasPurchased}
                  onStartMockTest={handleStartSelectedExamMockTest}
                  onViewMockReport={handleViewSelectedExamMockReport}
                  mockStarting={mockStarting}
                  mockSubmitted={welcomeMockSubmitted}
                />

                {renderExploreMockTests()}

                <div>
                  
     <div className="grid grid-cols-4 items-start gap-4">
                    {quickActions.map((action) => {
                      const Icon = action.icon;

                      return (
                        <Link key={action.title} to={action.link} className="block">
                        <div
                          key={action.title}
                          className="rounded-2xl border border-gray-100 bg-white p-4 shadow-[0_14px_35px_rgba(63,63,68,0.08)]"
                        >
                          <div className="flex items-center justify-between gap-3">
                            <div className="flex items-center gap-3">
                              <div
                                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${action.iconWrap}`}
                              >
                                <Icon className={`h-7 w-7 ${action.iconColor}`} />
                              </div>
                              <div className="text-left">
                                <h3 className="text-sm font-bold text-[#171321]">
                                  {action.title}
                                </h3>
                                <p className="mt-1 text-xs font-medium text-gray-500">
                                  {action.subtitle}
                                </p>
                              </div>
                            </div>

                            <button
                              type="button"
                              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-white shadow-md ${action.button}`}
                              aria-label={action.title}
                            >
                              <ArrowRight className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>

                <div>
                 
                  <ChallengeCard className="pb-20 lg:pb-0" />
                </div>

                {/* <div>
                  <h2 className="mb-4 text-xl text-left font-bold text-[#171321]">
                    Continue Learning
                  </h2>
                  <div className="grid grid-cols-[86px_1fr_220px_170px] items-center gap-5 rounded-3xl border border-gray-100 bg-white p-4 shadow-[0_18px_45px_rgba(63,63,68,0.08)]">
                    <img
                      src={courseThumb}
                      alt=""
                      className="h-20 w-20 rounded-2xl object-cover"
                    />
                    <div className="text-left">
                      <h3 className="text-base font-bold text-[#171321]">
                       {userData?.planName || "Government Exam Combo Plan"}
                      </h3>
                      <p className="mt-2 text-xs text-gray-500">Current Topic</p>
                      <p className="text-sm font-semibold text-[#171321]">
                        Indian Polity - Fundamental Rights
                      </p>
                      <div className="mt-3 flex items-center gap-3">
                        <div className="h-1.5 flex-1 rounded-full bg-gray-100">
                          <div
                            className="h-full rounded-full bg-[#6E32B7]"
                            style={{ width: `${courseProgress}%` }}
                          />
                        </div>
                        <span className="text-xs font-semibold text-gray-500">
                          {courseProgress}%
                        </span>
                      </div>
                    </div>
                    <div className="rounded-2xl bg-[#F8F6FB] p-4 text-left">
                      <p className="text-xs text-gray-500">Next Topic</p>
                      <p className="mt-1 text-sm font-semibold text-[#171321]">
                        Directive Principles of State Policy
                      </p>
                    </div>
                    <button className="flex h-12 items-center justify-center gap-3 rounded-2xl bg-[#6E32B7] font-semibold text-white shadow-[0_12px_24px_rgba(110,50,183,0.2)]">
                      Resume <ArrowRight className="h-4 w-4" />
                    </button>
                  </div>
                </div> */}
              </div>

              <div className="space-y-5">
                <CreditBalanceCard />
                <PerformanceSection userData={userData} userAnalysis={userAnalaysis} />
                {/* <div className="min-h-[280px] rounded-3xl border border-gray-100 bg-white p-5 shadow-[0_18px_45px_rgba(63,63,68,0.08)]">
                  <div className="mb-5 flex items-center justify-between">
                    <h3 className="text-base font-bold text-[#171321]">
                      Weekly Progress
                    </h3>
                    <button
                      type="button"
                      className="rounded-lg bg-[#F8F6FB] px-3 py-1.5 text-xs font-semibold text-[#34163F]"
                    >
                      This Week
                    </button>
                  </div>

                  <div className="space-y-5">
                    <div>
                      <div className="mb-2 flex items-center justify-between text-sm">
                        <span className="font-medium text-[#171321]">Quizzes</span>
                        <span className="text-gray-600">8 / 20</span>
                      </div>
                      <div className="h-1.5 rounded-full bg-gray-100">
                        <div className="h-full w-[40%] rounded-full bg-[#6E32B7]" />
                      </div>
                    </div>

                    <div>
                      <div className="mb-2 flex items-center justify-between text-sm">
                        <span className="font-medium text-[#171321]">Contests</span>
                        <span className="text-gray-600">3 / 10</span>
                      </div>
                      <div className="h-1.5 rounded-full bg-gray-100">
                        <div className="h-full w-[30%] rounded-full bg-[#FF8A1C]" />
                      </div>
                    </div>

                    <div>
                      <div className="mb-2 flex items-center justify-between text-sm">
                        <span className="font-medium text-[#171321]">Study Time</span>
                        <span className="text-gray-600">4h 30m / 10h</span>
                      </div>
                      <div className="h-1.5 rounded-full bg-gray-100">
                        <div className="h-full w-[45%] rounded-full bg-[#38A458]" />
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-1 gap-4 mx-4 my-2 items-stretch lg:hidden">
              <WelcomeCard
                hasPurchased={hasPurchased}
                onStartMockTest={handleStartSelectedExamMockTest}
                onViewMockReport={handleViewSelectedExamMockReport}
                mockStarting={mockStarting}
                mockSubmitted={welcomeMockSubmitted}
              />
              <CreditBalanceCard />
              <div className="flex justify-start py-1">
                <TopHeroMarquee data={data} />
              </div>
              <div className="flex flex-col gap-4 w-full">
                <div className="hidden sm:block w-full">
                  <PerformanceSection userData={userData} />
                </div>
                <div className="pb-20">
                  <ChallengeCard />
                </div>
              </div>
            </div>

            <div className="hidden lg:grid lg:grid-cols-[70%_28%] gap-4 mx-2 my-2 items-start">
              <div className="min-w-0 space-y-4">
                <WelcomeCard
                  hasPurchased={hasPurchased}
                  onStartMockTest={handleStartSelectedExamMockTest}
                  onViewMockReport={handleViewSelectedExamMockReport}
                  mockStarting={mockStarting}
                  mockSubmitted={welcomeMockSubmitted}
                />
                <TopHeroMarquee data={data} />
                <div className="pb-20 lg:pb-0">
                  <ChallengeCard />
                </div>
              </div>

              <div className="min-w-0 space-y-5">
                <CreditBalanceCard />
                <PerformanceSection userData={userData} />
              </div>
            </div>
          </>
        )}

        {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mx-2">
          <ReportSection />
          <PerformanceSection />
        </div> */}
      </div>
    </div>
  );
};

export default StartQuizepage2;
